import type { StayPlanStatus } from "@/hooks/useStayPlanStatus";

export const RESERVATION_BLOCKING_PLAN_ALERTS = ["overdue", "week_quota_exceeded"] as const;

export function getReservationPlanBlockingAlerts(status: Pick<StayPlanStatus, "alerts"> | null) {
  return status?.alerts.filter((alert): alert is typeof RESERVATION_BLOCKING_PLAN_ALERTS[number] =>
    RESERVATION_BLOCKING_PLAN_ALERTS.includes(alert as typeof RESERVATION_BLOCKING_PLAN_ALERTS[number]),
  ) ?? [];
}
